import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@user-portal/wikr-components';

import { getLanguage } from 'api/utils/languageManagment';

import { getVideoInstructionLink } from 'helpers/getVideoInstructionLink';

import Modal from 'components/Modal';

import * as S from './styled';

export interface VideoInstructionModalProps {
    onClose: () => void;
    title: string;
    device: string;
}

const VideoInstructionModal = ({ onClose, title, device }: VideoInstructionModalProps) => {
    const { t } = useTranslation();
    const userLanguage = getLanguage();

    return (
        <Modal isOpen onClose={onClose} withCloseButton width={648} height={466}>
            <Box $backgroundColor="surface-default" $borderRadius={12}>
                <Text type="h6" bold center mb={8}>
                    {t(title)}
                </Text>
                <Text center mb={16}>
                    {t('videoInstructionModal.subtitle')}
                </Text>
                <S.VideoWrapper>
                    <video playsInline controls width={600} height={338}>
                        <source src={getVideoInstructionLink(userLanguage, device)} type="video/mp4" />
                    </video>
                </S.VideoWrapper>
            </Box>
        </Modal>
    );
};

export default VideoInstructionModal;
